import React from 'react'
import { Row, Col, FormGroup, FormControl, ControlLabel, Modal } from 'react-bootstrap'
import i18next from 'i18next'
import moment from 'moment'
import GridContainer from './GridContainer'
import Button from './Button'

import adminStyles from './styles/admin.scss'

export default class OrganisationEdit extends React.Component {
  constructor(props) {
    super(props)

    const { name, notes, unitPriceWopi } = props.organisation

    this.state = {
      name,
      notes,
      unitPriceWopi,
      addCreditsWopi: 0,
      addCreditsWopi360: 0,
      isValid: true,
      deleteModalOpen: false
    }
  }

  render() {
    const { organisation, accountOrganisation } = this.props

    return (
      <GridContainer>
        <div className={adminStyles.app}>
          <header>
            <h1>{i18next.t('edit_organisation')}</h1>
          </header>

          <h3>{organisation.name}</h3>

          <Row>
            <Col md={12}>
              <FormGroup controlId="name">
                <ControlLabel>{i18next.t('organisation_name')}</ControlLabel>
                <FormControl
                  name="name"
                  type="text"
                  onChange={this.handleChange}
                  value={this.state.name}
                />
              </FormGroup>

              <FormGroup controlId="notes">
                <ControlLabel>{i18next.t('notes')}</ControlLabel>

                <FormControl
                  name="notes"
                  componentClass="textarea"
                  onChange={this.handleChange}
                  value={this.state.notes}
                  rows="8"
                />
              </FormGroup>

              <FormGroup controlId="unitPriceWopi">
                <ControlLabel>{i18next.t('unit_price_wopi')}</ControlLabel>

                <FormControl
                  name="unitPriceWopi"
                  type="text"
                  onChange={this.handleChange}
                  value={this.state.unitPriceWopi}
                />
              </FormGroup>

              <p>
                {i18next.t('wopi_credits_left')}: <strong>{organisation.creditsWopi}</strong>
              </p>

              <FormGroup controlId="addCreditsWopi">
                <ControlLabel>{i18next.t('add_wopi_credits')}</ControlLabel>

                <FormControl
                  name="addCreditsWopi"
                  type="text"
                  onChange={this.handleChange}
                  value={this.state.addCreditsWopi}
                />
              </FormGroup>

              <p>
                {i18next.t('wopi_360_credits_left')}: <strong>{organisation.creditsWopi360}</strong>
              </p>

              <FormGroup controlId="addCreditsWopi360">
                <ControlLabel>{i18next.t('add_wopi_360_credits')}</ControlLabel>

                <FormControl
                  name="addCreditsWopi360"
                  type="text"
                  onChange={this.handleChange}
                  value={this.state.addCreditsWopi360}
                />
              </FormGroup>
            </Col>
          </Row>

          <div>
            <Button
              text={i18next.t('save')}
              onClick={this.handleSave}
              disabled={!this.state.isValid}
              style={{ marginRight: '10px' }}
            />

            {organisation.id !== accountOrganisation.id && (
              <Button warning text={i18next.t('delete')} onClick={this.handleDeleteModalOpen} />
            )}
          </div>

          {organisation.creditsHistory.length > 0 && (
            <Row style={{ marginTop: '20px' }}>
              <Col md={12}>
                <h3>{i18next.t('wopi_credits_history')}</h3>

                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>{i18next.t('wopi_credits_credits')}</th>
                        <th>{i18next.t('wopi_credits_added_at')}</th>
                        <th>{i18next.t('wopi_credits_added_by')}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {organisation.creditsHistory.map((creditsHistory, i) => (
                        <tr key={i}>
                          <td>
                            <strong>{creditsHistory.credits}</strong> {creditsHistory.product}
                          </td>
                          <td>{moment(creditsHistory.createdAt).format('dd l LT')}</td>
                          <td>
                            {creditsHistory.creatorGivenName} {creditsHistory.creatorFamilyName}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          )}
        </div>

        <Modal show={this.state.deleteModalOpen} onHide={this.handleDeleteModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>{i18next.t('delete_organisation_title')}</Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ borderRadius: 6 }}>
            <p>{i18next.t('delete_organisation_description')}</p>
            <Button text={i18next.t('delete_organisation')} onClick={this.handleDelete} />
          </Modal.Body>
        </Modal>
      </GridContainer>
    )
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value }, this.validateState)
  }

  validateState() {
    const validate = () =>
      this.state.name.trim() !== '' &&
      parseInt(this.state.unitPriceWopi) >= 0 &&
      !isNaN(parseInt(this.state.addCreditsWopi)) &&
      !isNaN(parseInt(this.state.addCreditsWopi360))

    this.setState({ isValid: validate() })
  }

  handleSave = e => {
    const { onUpdate, organisation } = this.props
    const { name, notes, unitPriceWopi, addCreditsWopi, addCreditsWopi360 } = this.state

    onUpdate(organisation.id, name, notes, unitPriceWopi, addCreditsWopi, addCreditsWopi360)
  }

  handleDeleteModalOpen = () => {
    this.setState({ deleteModalOpen: true })
  }

  handleDeleteModalClose = () => {
    this.setState({ deleteModalOpen: false })
  }

  handleDelete = () => {
    this.props.onDelete(this.props.organisation.id)
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganisationEdit.js